import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {Page} from '../../../shared/models/page.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {ErrorMarginsService} from '../../services/error-margins.service';
import {MessageService} from '../../../shared/services/message.service';
import {ErrorMargins} from '../../models/error-margins.interface';

@Component({
  selector: 'app-error',
  templateUrl: './error-margins.component.html',
  styleUrls: ['./error-margins.component.scss']
})
export class ErrorMarginsComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  errors!: Page<ErrorMargins>;
  searchParams = '';
  private page: PageRequest = {page: 0, size: 100, sort: 'id', direction: 'asc'};

  constructor(private readonly router: Router,
              private readonly errorService: ErrorMarginsService,
              private messageService: MessageService) { }

  ngOnInit(): void {
    this.errorService.getAll('', this.page).subscribe(
      data => this.errors = data
    );
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  searchErrors(keyFigure: string): void {
    this.searchParams = keyFigure;
    this.errorService.getAll(keyFigure, this.page).subscribe(
      data => this.errors = data
    );
  }

  loadErrors(event: PageRequest): void {
    this.page = event;
    this.errorService.getAll(this.searchParams, event).subscribe(
      data => this.errors = data
    );
  }

}
